import { Component, OnInit } from '@angular/core';
import {ListeParution} from '../../../../../model/liste/ListeParution';
import {Client} from '../../../../../model/client/Client';
import {Parution} from '../../../../../model/parution/Parution';
import {AuthShareService} from '../../../../../service/partage/AuthShareService';
import {ClientService} from '../../../../../service/interne/client/ClientService';
import {ParutionService} from '../../../../../service/interne/parution/parutionService';
import {DialogueShareService} from '../../../../../service/partage/utilitaire/DialogueShareService';
import {ListeParutionService} from '../../../../../service/interne/parution/ListeParutionService';
import {ActivatedRoute} from '@angular/router';
import {forEach} from '@angular/router/src/utils/collection';
import {ParutionContact} from '../../../../../model/parution/ParutionContact';
import {ListeParutionParution} from '../../../../../model/liste/ListeParutionParution';

@Component({
  selector: 'app-escal-liste-parution-modifier',
  templateUrl: './escal-liste-parution-modifier.component.html',
  styleUrls: ['./escal-liste-parution-modifier.component.scss'],
  providers: [ ClientService, ParutionService, ListeParutionService ]
})
export class EscalListeParutionModifierComponent implements OnInit {

  private sub: any;
  listeParution: ListeParution;
  clients: Array<Client>;
  clientId: number;
  parutions: Array<Parution>;
  parutionsIds: Array<any> = [];
  parutionsChoix: Array<Parution>;
  parutionsClient: Array<Parution>;
  idParutionsSelectionnees: Array<any> = [];
  idParutionsASauvegarder: Array<any> = [];
  parutionSelect: Parution;
  assosParutionsListe: Array<ListeParutionParution>;
  listeId: number;
  cree: boolean;
  redirection: boolean;
  constructor(private authShareService: AuthShareService, private clientService: ClientService,
              private parutionService: ParutionService, private dialogueShareService: DialogueShareService,
              private listeParutionService: ListeParutionService, private route: ActivatedRoute) { }

  ngOnInit() {
    let parutionPresent;
    this.cree = false;
    this.redirection = false;
    this.listeId = 0;
    this.parutions = [];
    this.parutionsChoix = [];
    this.parutionsClient = [];
    this.assosParutionsListe = [];
    this.clientId = 0;
    this.clientService.getAllClients().then((clients) => {
      this.clients = clients['hydra:member'] as Array<Client>;
    });
    this.sub = this.route.params.subscribe(params => {
      this.listeParutionService.getListeParutionDetails(params.id)
        .then((listeParution) => {
          this.listeParution = listeParution as ListeParution;
          if (this.listeParution.client != null) {
            this.clientId = this.listeParution.client.id;
            // on récupère toutes les parutions du client
            this.parutionService.getParutionsClient(this.clientId).then(async (parutionsClient) => {
              this.parutionsClient = parutionsClient['hydra:member'] as Array<Parution>;
              // on récupère toutes les parutions associées à la liste
              await this.listeParutionService.getParutionsListeAssociees(this.listeParution.id).then((parutionsListe) => {
                this.parutions = parutionsListe['hydra:member'] as Array<Parution>;
                this.parutionsClient.forEach(parutionClient => {
                  parutionPresent = this.parutions.find((list) => list.id === parutionClient.id);
                  if (parutionPresent === undefined) {
                    this.parutionsChoix.push(parutionClient);
                  }
                });
              });
            });
          } else {
            this.listeParutionService.getParutionsListeAssociees(this.listeParution.id).then((parutionsListe) => {
              this.parutions = parutionsListe['hydra:member'] as Array<Parution>;
              this.parutionsClient.forEach(parutionClient => {
                parutionPresent = this.parutions.find((list) => list.id === parutionClient.id);
                if (parutionPresent === undefined) {
                  this.parutionsChoix.push(parutionClient);
                }
              });
            });
          }
        });
      this.listeParutionService.getAssoParutionListe(params.id).then((assosParutionsListe) => {
        this.assosParutionsListe = assosParutionsListe['hydra:member'] as Array<ListeParutionParution>;
      });
    });
  }

  changeClient() {
    this.parutionsChoix = [];
    let parutionPresent;
    // on récupère toutes les parutions du client
    this.parutionService.getParutionsClient(this.clientId).then(async (parutionsClient) => {
      this.parutionsClient = parutionsClient['hydra:member'] as Array<Parution>;
      // on récupère toutes les parutions associées à la liste
      await this.listeParutionService.getParutionsListeAssociees(this.listeParution.id).then((parutionsListe) => {
        this.parutions = parutionsListe['hydra:member'] as Array<Parution>;
        this.parutionsClient.forEach(parutionClient => {
          parutionPresent = this.parutions.find((list) => list.id === parutionClient.id);
          if (parutionPresent === undefined) {
            this.parutionsChoix.push(parutionClient);
          }
        });
      });
    });
  }

  setSelected(selectElement, action, nature) {
    const groupe: Array<any> = [];
    let optionSelected;
    for (let i = 0; i < selectElement.options.length; i++) {
      if (selectElement.options[i].selected) {
        optionSelected = selectElement.options[i].value;
        // Le format de value est de [0: '1']
        if (optionSelected.indexOf('\'') !== -1) {
          // extraire le vrai id sauvegarder
          optionSelected = optionSelected.indexOf('\'');
          optionSelected = selectElement.options[i].value.slice(optionSelected);
          optionSelected = this.extraitNombre(optionSelected);
          optionSelected = optionSelected.toString();
        }
        groupe.push(optionSelected);
      }
    }
    if (action === 'add') {
      switch (nature) {
        case 'liste':
          this.idParutionsSelectionnees = groupe;
          break;
      }
    } else if (action === 'delete') {
      switch (nature) {
        case 'liste':
          this.idParutionsASauvegarder = groupe;
          break;
      }
    }
  }

  extraitNombre(str) {
    return Number(str.replace(/\D/g, ''));
  }

  changeParution(action) {
    const that = this;
    let nouvelleListeParutions;
    let listeParutions;
    let parutionPresent;
    if (action === 'add') {
      listeParutions = this.idParutionsSelectionnees;
    } else {
      listeParutions = this.idParutionsASauvegarder;
    }
    listeParutions.forEach((idParutionSelectionnees) => {
      that.parutionService.getParutionDetails(idParutionSelectionnees).then(retour => {
        that.parutionSelect = retour as Parution;
        if (action === 'add') {
          // retirer la(es) parution(s) sélectionnée(s) dans la liste de langue de base
          nouvelleListeParutions = this.parutionsChoix.filter((parution) => parution.id !== that.parutionSelect.id);
          this.parutionsChoix = nouvelleListeParutions;
          // évite les doublons
          parutionPresent = this.parutions.find((langue) => langue.id === that.parutionSelect.id);
          if (parutionPresent === undefined) {
            this.parutions.push(that.parutionSelect);
          }
        } else if (action === 'delete') {
          // retirer la(es) parution(s) sélectionnée(s) dans la liste de langue à sauvegarder
          nouvelleListeParutions = this.parutions.filter((langue) => langue.id !== that.parutionSelect.id);
          this.parutions = nouvelleListeParutions;
          // évite les doublons
          parutionPresent = this.parutionsChoix.find((langue) => langue.id === that.parutionSelect.id);
          if (parutionPresent === undefined) {
            this.parutionsChoix.push(that.parutionSelect);
          }
        }
      });
    });
  }

  modifierListe() {
    // si informations obligatoires non renseignées
    if (this.listeParution.nom != '') {
      // empeche la creation de multiple liste
      this.cree = true;
      // modfier liste
      this.listeParutionService.modifierListeParution(this.listeParution, this.clientId).then(async listeParution => {
        this.listeId = listeParution.id;
        if (this.parutions.length > 0) {
          for (const assoParutionsListe of this.assosParutionsListe) {
            // Sinon mettre à jour les assos via la selection dans le formulaire escalnet
            await this.listeParutionService.deleteAssoParutionListe(assoParutionsListe.id).then(() => {
            });
          }
          for (const parution of this.parutions) {
            await this.listeParutionService.addParutionListe(this.listeId, parution.id);
          }
        } else {
          for (const assoParutionsListe of this.assosParutionsListe) {
            await this.listeParutionService.deleteAssoParutionListe(assoParutionsListe.id).then(() => {
            });
          }
        }
        // enregistrer liste parution dans la base d'intranet
        await this.listeParutionService.importerListeParutionIntranet(listeParution.id, this.listeParution.ancienId)
          .then(async (ancienIdListe) => {
          this.dialogueShareService.addDialogue('La liste a bien été modifiée');
          this.redirection = true;
        });
      });
    } else {
      this.dialogueShareService.addDialogue('Le nom est obligatoire');
    }
  }

}
